import { JSONObject } from 'module/types/common';
import { HttpClient } from '../http-client';

export enum FormatDocumentOperationType {
  EnhanceWithMyNotes = 'ENHANCE_WITH_NOTES',
  MakeLonger = 'MAKE_LONGER',
  MakeShorter = 'MAKE_SHORTER',
}
export type FormatDocumentContentParams = {
  documentId: number;
  operationType: FormatDocumentOperationType;
  tiptapPayload: JSONObject;
  question?: string;
  isStreaming?: boolean;
};
export type FormatDocumentContentResponse = {
  response: {
    content: JSONObject[];
  };
  streamingMeta: {
    token: string;
    channelName: string;
  };
  promptIdList: string[];
};
class DocumentContentFormatterClient extends HttpClient {
  public async formatDocumentContent(params: FormatDocumentContentParams) {
    return this.post<
      FormatDocumentContentResponse,
      Omit<FormatDocumentContentParams, 'documentId'>
    >(
      `semantic-formatting/document/${params.documentId}?streaming=${params.isStreaming ?? true}`,
      {
        operationType: params.operationType,
        tiptapPayload: params.tiptapPayload,
        question: params.question,
      },
    );
  }
}

export const DocumentContentFormatterAPI = new DocumentContentFormatterClient();
